import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Calendar, Clock, ArrowRight, AlertTriangle, CheckSquare } from 'lucide-react';

const MegaTimeline = () => {
  const [expandedGroups, setExpandedGroups] = useState({});

  const toggleGroup = (group) => {
    setExpandedGroups(prev => ({
      ...prev,
      [group]: !prev[group]
    }));
  };

  const projectGroups = {
  "Core Infrastructure": {
  color: "bg-blue-500",
  projects: [
    {
      name: "NEOCORE",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 2 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: []
    },
    {
      name: "DATACORE",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: []
    },
    {
      name: "QUANTUMOPEN", 
      phases: [
        { name: "R&D", start: "2025-Q4", duration: 1 },
        { name: "Development", start: "2026-Q1", duration: 1 },
        { name: "Tests", start: "2026-Q2", duration: 1 }
      ],
      dependencies: ["NEOCORE"]
    }
  ]
},

"Security & Compliance": {
  color: "bg-red-500", 
  projects: [
    {
      name: "RISKMATRIX",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["DATACORE"]
    },
    {
      name: "COMPLIANCEWATCH",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["RISKMATRIX"]
    },
    {
      name: "REGTECHPLUS",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["COMPLIANCEWATCH"]
    }
  ]
},
"Digital Banking & CX": {
  color: "bg-green-500",
  projects: [
    {
      name: "SMARTCRM",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["NEOCORE"]
    },
    {
      name: "CHATBANK",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["SMARTCRM"]
    },
    {
      name: "BRANCHFUTURE",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["SMARTCRM"]
    },
    {
      name: "BRANCHTRANSFORM",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["BRANCHFUTURE"]
    }
  ]
},

"Wealth & Asset Management": {
  color: "bg-purple-500",
  projects: [
    {
      name: "WEALTHSPHERE",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["DATACORE"]
    },
    {
      name: "WEALTHMAP",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["WEALTHSPHERE"]
    },
    {
      name: "ASSETX",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["WEALTHSPHERE"]
    },
    {
      name: "VIPBANKING",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["WEALTHSPHERE"]
    },
    {
      name: "FUNDMATRIX",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["WEALTHSPHERE"]
    }
  ]
},
"Payments & Cards": {
  color: "bg-yellow-500",
  projects: [
    {
      name: "CARDMASTER",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["NEOCORE"]
    },
    {
      name: "CHAINPAY",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["CARDMASTER"]
    },
    {
      name: "INSTANTBANKING",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["CARDMASTER"]
    },
    {
      name: "MXPAY",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["CHAINPAY"]
    },
    {
      name: "PAYLEARNING",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["CHAINPAY"]
    }
  ]
},

"Lending & Credit": {
  color: "bg-orange-500",
  projects: [
    {
      name: "CREDITFLOW",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["NEOCORE"]
    },
    {
      name: "LOANBOT",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["CREDITFLOW"]
    },
    {
      name: "LOANSCAPE",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["CREDITFLOW"]
    },
    {
      name: "FACTORPLUS",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["CREDITFLOW"]
    },
    {
      name: "CHAINLEND",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["CREDITFLOW"]
    }
  ]
},

"Security & Identity": {
  color: "bg-indigo-500",
  projects: [
    {
      name: "BIOPORTAL",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["NEOCORE"] 
    },
    {
      name: "IDENTRACK",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["BIOPORTAL"]
    },
    {
      name: "FRAUDSHIELD",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["BIOPORTAL"]
    },
    {
      name: "PENTEST360",
      phases: [
        { name: "R&D", start: "2025-Q3", duration: 1 },
        { name: "Development", start: "2025-Q4", duration: 1 },
        { name: "Tests", start: "2026-Q1", duration: 1 }
      ],
      dependencies: ["FRAUDSHIELD"]
    }
  ]
},
"ESG & Sustainability": {
  color: "bg-emerald-500",
  projects: [
    {
      name: "GREENMETRICS",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["DATACORE"]
    },
    {
      name: "SUSTAINBANK",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["GREENMETRICS"]
    }
  ]
},

"Market Intelligence": {
  color: "bg-cyan-500",
  projects: [
    {
      name: "MARKETINTEL",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["DATACORE"]
    },
    {
      name: "MARKETPULSE",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["MARKETINTEL"]
    },
    {
      name: "BENCHMATRIX",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["MARKETINTEL"]
    }
  ]
},

"Treasury & Trading": {
  color: "bg-violet-500",
  projects: [
    {
      name: "TREASURYPLUS",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["NEOCORE"]
    },
    {
      name: "LIQUIDITYAI",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["TREASURYPLUS"]
    }
  ]
},

"Document & Data Management": {
  color: "bg-slate-500",
  projects: [
    {
      name: "SMARTDOC",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["DATACORE"]
    },
    {
      name: "DATAQUALITY",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["SMARTDOC"]
    }
  ]
},

"Trade & Supply Chain": {
  color: "bg-amber-500",
  projects: [
    {
      name: "TRADEFINANCEPLUS",
      phases: [
        { name: "R&D", start: "2025-Q1", duration: 1 },
        { name: "Development", start: "2025-Q2", duration: 1 },
        { name: "Tests", start: "2025-Q3", duration: 1 }
      ],
      dependencies: ["NEOCORE"]
    },
    {
      name: "DLTRADE",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["TRADEFINANCEPLUS"]
    },
    {
      name: "SUPPLYBANK",
      phases: [
        { name: "R&D", start: "2025-Q2", duration: 1 },
        { name: "Development", start: "2025-Q3", duration: 1 },
        { name: "Tests", start: "2025-Q4", duration: 1 }
      ],
      dependencies: ["TRADEFINANCEPLUS"]
    }
    ]
  }
};
  const quarters = [
    "2025-Q1", "2025-Q2", "2025-Q3", "2025-Q4",
    "2026-Q1", "2026-Q2", "2026-Q3", "2026-Q4"
  ];

  const getQuarterPosition = (quarter) => {
    return quarters.indexOf(quarter) * 150;
  };

  const renderPhase = (phase, projectColor) => {
    const startPos = getQuarterPosition(phase.start);
    const width = phase.duration * 150 - 10;
    
    return (
      <div 
        className={`absolute h-8 ${projectColor} bg-opacity-20 border-l-4 ${projectColor} rounded-r`}
        style={{
          left: `${startPos}px`,
          width: `${width}px`,
          top: '4px'
        }}
      >
        <span className="text-xs font-medium px-2 truncate block">{phase.name}</span>
      </div>
    );
  };

  return (
    <div className="p-6 max-w-full overflow-x-auto">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-8 rounded-xl shadow-lg mb-8 sticky top-0 z-50">
        <h1 className="text-3xl font-bold text-white mb-4">Mega Timeline 2025-2026</h1>
        <p className="text-white opacity-90">
          Planning détaillé du développement et déploiement de l'écosystème bancaire
        </p>
      </div>

      {/* Timeline Grid */}
      <div className="relative min-w-[1200px]">
        {/* Quarter Headers */}
        <div className="flex mb-8 sticky top-32 bg-white z-40 pt-4">
          <div className="w-64 flex-shrink-0"></div>
          {quarters.map(quarter => (
            <div key={quarter} className="w-[150px] flex-shrink-0">
              <div className="px-4 py-2 bg-gray-100 rounded-lg text-center font-semibold">
                {quarter}
              </div>
            </div>
          ))}
        </div>

        {/* Projects Timeline */}
        <div className="relative">
          {Object.entries(projectGroups).map(([groupName, group]) => (
            <div key={groupName} className="mb-8">
              {/* Group Header */}
              <div 
                className="flex items-center mb-4 cursor-pointer bg-gray-50 p-4 rounded-lg"
                onClick={() => toggleGroup(groupName)}
              >
                {expandedGroups[groupName] ? <ChevronUp className="mr-2" /> : <ChevronDown className="mr-2" />}
                <h3 className="text-xl font-semibold">{groupName}</h3>
              </div>

              {/* Group Projects */}
              {expandedGroups[groupName] && (
                <div className="space-y-6">
                  {group.projects.map(project => (
                    <div key={project.name} className="relative">
                      {/* Project Header */}
                      <div className="flex mb-2">
                        <div className="w-64 flex-shrink-0">
                          <div className="flex items-center space-x-2">
                            <div className={`w-3 h-3 rounded-full ${group.color}`}></div>
                            <span className="font-medium">{project.name}</span>
                          </div>
                          {project.dependencies.length > 0 && (
                            <div className="text-xs text-gray-500 mt-1">
                              Dépend de: {project.dependencies.join(', ')}
                            </div>
                          )}
                        </div>

                        {/* Timeline */}
                        <div className="flex-grow relative h-16">
                          {project.phases.map((phase, index) => 
                            renderPhase(phase, group.color)
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Milestones & Dependencies */}
        <div className="mt-12 bg-yellow-50 p-6 rounded-xl border border-yellow-200">
          <div className="flex items-start space-x-8">
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-yellow-800 mb-4 flex items-center">
                <AlertTriangle className="mr-2" />
                Jalons Critiques
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <CheckSquare className="mr-2 text-green-500" />
                  <span>Q2 2025: Socle Core Banking opérationnel (NEOCORE + DATACORE)</span>
                </li>
                <li className="flex items-center">
                  <CheckSquare className="mr-2 text-green-500" />
                  <span>Q4 2025: Déploiement solutions digitales (SMARTCRM + CHATBANK)</span>
                </li>
                <li className="flex items-center">
                  <CheckSquare className="mr-2 text-green-500" />
                  <span>Q2 2026: Lancement solutions blockchain (CHAINPAY)</span>
                </li>
              </ul>
            </div>

            <div className="flex-1">
              <h3 className="text-lg font-semibold text-yellow-800 mb-4">
                Points d'Attention
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <Clock className="mr-2 text-yellow-500" />
                  <span>Validation réglementaire requise pour chaque phase</span>
                </li>
                <li className="flex items-center">
                  <Clock className="mr-2 text-yellow-500" />
                  <span>Formation continue des équipes à planifier</span>
                </li>
                <li className="flex items-center">
                  <Clock className="mr-2 text-yellow-500" />
                  <span>Tests d'intégration approfondis entre solutions</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaTimeline;